module.exports = __webpack_public_path__ + "static/media/gp-badge.17615144.svg";